export default __webpack_public_path__ + "static/media/06.dc30937f.jpg";